<template>
  <div class="row">
    <div class="Search col m12">
      <div class="col s12 separator-top pt-6 pl-0">
        <span class="Search__title grey-text">
          Por data de criação:
        </span>
      </div>
    </div>
    <div class="input-field col s12">
      <masked-input
        id="data_ini"
        v-model="pesquisa.data_ini"
        mask="11/11/1111"
        placeholder="Data Inicial"
        type="text"
      />
      <masked-input
        id="data_fim"
        v-model="pesquisa.data_fim"
        mask="11/11/1111"
        placeholder="Data Final"
        type="text"
      />

      <button
        @click="inputData()"
        type="button"
        class="col s12 mb-4 btn-flat waves-effect btn-transparent">
        <i class="material-icons text-default"> send </i>
      </button>
    </div>
  </div>

</template>

<script>
import MaskedInput from "vue-masked-input";

import {validaData} from "@/helpers/validates";

export default {
  name: "FiltroPorData",

  components: {
    MaskedInput
  },

  props: {
    data_ini: {
      type: String,
      default: undefined
    },
    data_fim: {
      type: String,
      default: undefined
    }
  },


  data() {
      return {
        pesquisa: { data_ini: this.data_ini, data_fim: this.data_fim }
      }
  },

  methods: {
    inputData() {

      this.$emit('inputData', this.pesquisa);

      const datas_validas = ['data_ini', 'data_fim'].every( key => validaData(this.pesquisa[key]) )

      const resultado = (datas_validas) ? this.pesquisa : {data_ini: null, data_fim: null};

      this.$emit('change', resultado);

      this.$emit('update:data_ini', resultado.data_ini);
      this.$emit('update:data_fim', resultado.data_fim);

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lead/listagem/FiltroPorData.vue